export default class Base {
  __inst_id = null;

  constructor(modelKey = "base_model") {
    this.__inst_id = `${modelKey}::${
      new Date().getTime() / 10000 / Math.random() + Math.random()
    }`;
  }
}
